module.exports = __webpack_public_path__ + "static/media/cloudy.6a9f0b76.svg";